import { useController, UseControllerProps } from "react-hook-form";

import { Checkbox } from "primereact/checkbox";

import { LabelForm } from "@/common/components/form/LabelForm.tsx";

interface ICheckBoxProps {
  label: string;
  disabled?: boolean;
}

type Props = UseControllerProps & ICheckBoxProps;

export const CheckBox: React.FC<Props> = (props) => {
  const { field } = useController(props);
  return (
    <div className="d-flex align-items-center gap-2 small">
      <Checkbox
        onChange={(e) => field.onChange(e.checked)}
        checked={field.value}
        disabled={props.disabled}
        value={!!field.value}
      ></Checkbox>
      <div className={"mb-2"}>
        <LabelForm label={props.label} />
      </div>
    </div>
  );
};
